import * as React from 'react';
import { Box, Text, Radio } from '@televet/kibble-ui';

interface AutomationsRadioFieldProps {
  label: string;
  description: string;
  value: string;
  isChecked: boolean;
  onChange: () => void;
}

export const AutomationsRadioField = ({
  label,
  description,
  value,
  isChecked,
  onChange,
}: AutomationsRadioFieldProps): JSX.Element => {
  return (
    <Box
      borderRadius="md"
      py={3}
      px={4}
      border="1px"
      borderColor="border.default"
      _hover={{
        borderColor: 'border.strong',
      }}
      mb={3}
      cursor="pointer"
      onClick={onChange}
      className="Automations_Radio"
    >
      <Radio size="lg" value={value} isChecked={isChecked} className="Automations_RadioInput" />
      <Text as="span" size="md" ml={3} fontWeight="bold" className="Automations_RadioLabel">
        {label}
      </Text>
      <Text as="p" size="md" variant="subtle" ml={7} mt={1} className="Automations_RadioDescription">
        {description}
      </Text>
    </Box>
  );
};
